export default `
  mutation createCardAttachment($workflowId: String, $input: CreateCardAttachmentInput!) {
    createCardAttachment(workflowId: $workflowId, input: $input) {
      id
      type
      url
      dateCreated
      name
      mimeType
      cardId
      workflowId
    }
  }
`
